import { render, staticRenderFns } from "./UpdateContactAddress.vue?vue&type=template&id=fd021b06"
import script from "./UpdateContactAddress.vue?vue&type=script&lang=js"
export * from "./UpdateContactAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports